export default class Helper {
	static form(element) {
		const data = {};
		const form = jQuery(element);
		form.find('input, select, textarea, button, checkbox').each(function() {
			if (this.name && !this.disabled)
				data[this.name] = $(this).val();
		});

		return data;
	}

	static strip(content) {
		return content.replace(/<[^>]+>/g, '');
	}

	static clean(content) {
		content = content.trim();
		content = content.replace(/\s{2,}/g, ' ');
		return content;
	}

	static equals(content, check) {
		const equals = false;
		if (Array.isArray(content)) {
			const lower = content.map(item => item.toLowerCase());
			equals = lower.includes(check.toLowerCase());
		}
		else equals = content.toLowerCase() === check.toLowerCase();
		return equals;
	}

	static is() {
		const empty = content => {
			let empty = true;
			for (const key in content) {
				empty = false;
				break;
			}

			return empty;
		};

		let is = false;
		for (const content of arguments) {
			switch (typeof content) {
				case 'boolean': is = content; break;
				case 'object': is = !empty(content); break;
				default: is = !!content; break;
			}

			if (!is) break;
		}

		return is;
	}

	static type(content, type) {
		return typeof content === type;
	}

	static undefined(content) {
		return Helper.type(content, 'undefined');
	}

	static debounce(func, wait) {
		let timeout;
		return function executedFunction(...args) {
			const later = () => {
				timeout = null;
				func(...args);
		  	};
		  	clearTimeout(timeout);
		  	timeout = setTimeout(later, wait);
		};
	};

	static secondsToMinutes(seconds) {
		return moment.utc(seconds*1000).format('mm:ss');
	}

	static cardLoading(selector, state) {
		if(state)
			$(selector).fadeIn(500)
		else
			$(selector).fadeOut(500)
	}
}
